
<div class="disclaimer">
  <small>
    @if (showSesssion) {
      <span>Session ID <strong>{{sessionDetails().session_id}}</strong> ‐ </span>
    }
    EIDI is a licensed financial services provider with FSP 21271.
  </small>
</div>

